import { Paragraph } from 'applaus-ui-kit'
import { AnimatePresence } from 'framer-motion'
import { ReactChild, useState } from 'react'
import * as S from './Accordion.styles'

type Props = {
  title: string
  child: ReactChild
}

export const Accordion = ({ title, child }: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <S.Container>
      <S.Header>
        <Paragraph variant="regular" type="semiBold">
          {title}
        </Paragraph>
        <S.IconBox
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3 }}
          onClick={() => setIsOpen((prev) => !prev)}>
          <S.ChevronIcon />
        </S.IconBox>
      </S.Header>
      <AnimatePresence>
        {isOpen ? (
          <S.AccordionInfo
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'max-content', opacity: 1 }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}>
            <Paragraph variant="small">{child}</Paragraph>
          </S.AccordionInfo>
        ) : undefined}
      </AnimatePresence>
    </S.Container>
  )
}
